import axios from '@/lib/AxApi';

export default
{
    async selectRow(params)
    {
        try
        {
            const response = await axios.get('/Rules/selectRow',
                {
                    params,
                });
            return response.data;
        }
        catch (error)
        {
            throw (error);
        }
    },
    async save(params)
    {
        try
        {
            let response;
            if (typeof params.id !== 'undefined' && params.id != '')
            {
                response = await axios.post('/Rules/updateRow', params);
            }
            else
            {
                response = await axios.post('/Rules/insertRow', params);
            }
            return response.data;
        }
        catch (error)
        {
            throw (error);
        }
    },
    async getConditions(params)
    {
        const response = await axios.get('/Rules/getConditions', { params });
        return response.data;
    },
    async saveConditions(params)
    {
        const response = await axios.post('/Rules/saveConditions', params);
        return response.data;
    },
    async getConditionSources(params)
    {
        const response = await axios.get('/Rules/getConditionSources', { params });
        return response.data;
    },
    async deleteRow(params)
    {
        try
        {
            const response = await axios.post('/Rules/deleteRow', params);
            return response.data;
        }
        catch (error)
        {
            throw (error);
        }
    },
};
